import { ForcedRankingsService } from 'src/services/ForcedRankingsService';

export const deleteForcedRankingStrategy = (
    { accessToken, strategyName }: App.ForcedRankings.DeleteMutationVariables,
): Promise<void> => ForcedRankingsService.deleteForcedRankingStrategy(accessToken, strategyName);
